export function parseAnswerContent(value) {
  try {
    return typeof value === "string" ? JSON.parse(value) : value;
  } catch {
    return null;
  }
}

export function cleanFileName(file) {
  return typeof file === "string" ? file.replace(/"/g, "").trim() : file;
}

export function getSubmissionAttachments(answerContent) {
  const parsed = parseAnswerContent(answerContent);

  if (!parsed) return [];

  if (Array.isArray(parsed)) {
    return parsed.map(cleanFileName).filter(Boolean);
  }

  if (parsed && typeof parsed === "object" && Array.isArray(parsed.files)) {
    return parsed.files.map(cleanFileName).filter(Boolean);
  }

  return [];
}